import type { FC } from "react";
import { BOARD_COLOR, BOARD_ICON_HEIGHT, JOIST_COLOR, JOIST_ICON_HEIGHT } from "./deckSlopeViewConstants";

type JoistWithBoardsIconProps = {
  left: number;
  right: number;
  joistBottomY: number;
  scale: number;
};

// Fixed-size pictogram of a joist with a few board profiles on top, standing in for the real
// (variable, detailed) build-up - not proportioned to any real dimension, just enough to read as
// "deck", per the request not to reuse a plain bar. Its own bottom edge is the support's start (the
// dimensioned "h"); a fixed visual gap above that stands in for the fixed board+joist stack (whose
// real thickness contributes to H but isn't itself dimensioned here).
const JoistWithBoardsIcon: FC<JoistWithBoardsIconProps> = ({ left, right, joistBottomY, scale }) => {
  const joistHeight = JOIST_ICON_HEIGHT * scale;
  const boardHeight = BOARD_ICON_HEIGHT * scale;
  const boardWidth = 24 * scale;
  const boardGap = 7 * scale;
  const joistTopY = joistBottomY - joistHeight;
  const boardsTopY = joistTopY - boardHeight;

  const boardCount = Math.max(Math.floor((right - left) / (boardWidth + boardGap)), 1);
  const rowWidth = boardCount * boardWidth + (boardCount - 1) * boardGap;
  const rowStart = left + (right - left - rowWidth) / 2;

  return (
    <g>
      <rect x={left} y={joistTopY} width={right - left} height={joistHeight} fill={JOIST_COLOR} />
      {Array.from({ length: boardCount }, (_, index) => (
        <rect
          key={index}
          x={rowStart + index * (boardWidth + boardGap)}
          y={boardsTopY}
          width={boardWidth}
          height={boardHeight}
          fill={BOARD_COLOR}
        />
      ))}
    </g>
  );
};

export default JoistWithBoardsIcon;
